//#region base_app_setting
// Inserisce sempre il record globale (TenantId null). Il FE non crea mai record scoped per tenant.
export const insert_base_app_setting_global = `
mutation insertBaseAppSettingGlobal($key: String!, $value: String!) {
    insert_base_app_setting_one(object: {Key: $key, Value: $value, TenantId: null}) {
        Id
        Key
        Value
    }
}`;
//#endregion

//#region base_mezzo_pagamento
export const mutation_add_base_mezzo_pagamento = `
mutation insertBaseMezzoPagamento($tenantId: String!, $key: String!, $value: String!, $order: Int!) {
    insert_base_mezzo_pagamento_one(object: {TenantId: $tenantId, Key: $key, Value: $value, Order: $order, IsSystem: false}) {
        Id
        TenantId
        Key
        Value
        Order
        IsSystem
    }    
}`;
export const mutation_update_base_mezzo_pagamento = `
mutation updateBaseMezzoPagamento($id: Int!, $tenantId: String!, $value: String!) {
    update_base_mezzo_pagamento(where: {Id: {_eq: $id}, TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}, _set: {Value: $value}) {
        returning {
            Id
            Key
            Value
            Order
            IsSystem
        }
    }
}`;
export const mutation_delete_base_mezzo_pagamento = `
mutation deleteBaseMezzoPagamento($tenantId: String!, $id: Int!) {
    delete_base_mezzo_pagamento(where: {Id: {_eq: $id}, IsSystem: {_eq: false}, TenantId: {_eq: $tenantId}}) {
        affected_rows
    }
}`;
//#endregion

//#region base_origine_fondi
export const mutation_add_base_origine_fondi = `
mutation insertBaseOrigineFondi($tenantId: String!, $key: String!, $value: String!, $order: Int!) {
    insert_base_origine_fondi_one(object: {TenantId: $tenantId, Key: $key, Value: $value, Order: $order, IsSystem: false}) {
        Id
        TenantId
        Key
        Value
        Order
        IsSystem
    }    
}`;
export const mutation_update_base_origine_fondi = `
mutation updateBaseOrigineFondi($id: Int!, $tenantId: String!, $value: String!) {
    update_base_origine_fondi(where: {Id: {_eq: $id}, TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}, _set: {Value: $value}) {
        returning {
            Id
            Key
            Value
            Order
            IsSystem
        }
    }
}`;
export const mutation_delete_base_origine_fondi = `
mutation deleteBaseOrigineFondi($tenantId: String!, $id: Int!) {
    delete_base_origine_fondi(where: {Id: {_eq: $id}, IsSystem: {_eq: false}, TenantId: {_eq: $tenantId}}) {
        affected_rows
    }
}`;
//#endregion

//#region base_tipo_documento
export const mutation_add_base_tipo_documento = `
mutation insertBaseTipoDocumento($tenantId: String!, $key: String!, $value: String!, $order: Int!, $documentTypeId:Int!, $validityMonths : Int, $offsetDays : Int, $nextBirthDay : Boolean, $personType : String) {
    insert_base_tipo_documento_one(object: {TenantId: $tenantId, Key: $key, Value: $value, Order: $order, IsSystem: false, DocumentTypeId : $documentTypeId, ValidityMonths : $validityMonths, ValidityOffsetDays : $offsetDays, NextBirthDay : $nextBirthDay, PersonType: $personType}) {        
        Id
        TenantId
        Key
        Value
        Order
        IsSystem
        DocumentTypeId
        PersonType
        ValidityMonths
        ValidityOffsetDays
        NextBirthDay
    }    
}`;
export const mutation_update_base_tipo_documento = `
mutation updateBaseTipoDocumento($id: Int!, $tenantId: String!, $value: String!, $documentTypeId : Int!, $validityMonths : Int, $validityOffsetDays : Int, $nextBirthDay : Boolean) {
    update_base_tipo_documento(where: {Id: {_eq: $id}, TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}, _set: {Value: $value, DocumentTypeId : $documentTypeId, ValidityMonths : $validityMonths, ValidityOffsetDays : $validityOffsetDays, NextBirthDay : $nextBirthDay}) {
        returning {
            Id
            Key
            Value
            Order
            IsSystem
        }
    }
}`;
export const mutation_delete_base_tipo_documento = `
mutation deleteBaseTipoDocumento($tenantId: String!, $id: Int!) {
    delete_base_tipo_documento(where: {Id: {_eq: $id}, IsSystem: {_eq: false}, TenantId: {_eq: $tenantId}}) {
        affected_rows
    }
}`;
//#endregion